import React, { Component } from 'react';
import firebase from 'firebase';
import { connect } from 'react-redux';
import { logUser,logoutUser,getIdea } from '../../actions';


import Loading from './Loading';
import Profile from './Profile';
import IdeaFrom from './IdeaForm';
import GetIdea from './GetIdea';
import '../../stylesheets/goal.css';

firebase.initializeApp({
    apiKey: 'AIzaSyDBTL6JqT9elEcBeMS_4CH3_X4vdlHQOJ8',
    authDomain:'react-mini-project.firebaseapp.com'
})

class Goal extends Component{
    constructor(props){
        super(props);
        this.state = { isSignedIn: false,isLoading:true,wordCounter:0,idea:'',toShow:null}
    }
    

      authenticate(providerName){
        const provider = {
            'google' : () => new firebase.auth.GoogleAuthProvider(),
            'facebook' : () => new firebase.auth.FacebookAuthProvider(),
            'github': () => new firebase.auth.GithubAuthProvider(),
            'twitter': () => new firebase.auth.TwitterAuthProvider(),

        }
        //console.log(provider[providerName]);
        firebase.auth().signInWithPopup(provider[providerName]())
          .then((result,error) => {
            if(error){
              //console.log('unable to signup with firebase')
            } else {
              //console.log('result',result);
              this.setState({isSignedIn: true })
            }
          }) 
      }

    componentDidMount(){
        firebase.auth().onAuthStateChanged(user => {
            this.setState({ isSignedIn: !!user });
            //console.log("user", user);
            if(user){
                user = user.providerData['0'];
                let pic = (user.providerId==='facebook.com') ? user.photoURL+'?type=large' : user.photoURL
                this.props.logUser({
                    id:user.uid,
                    name:user.displayName,
                    email:user.email,
                    pic,
                    provider:user.providerId
                });
                this.setState({isLoading:false});
            }else{
                this.props.logoutUser();
                this.setState({isLoading:false});
            }
          })
    }
    

    button(){
        return(
            <div className='App'>
            <div style={{fontSize:'.8em'}}><small>You need to be logged in to view this page.</small></div>
            <div>Login using - </div>
            <button 
            className='btn btn-outline-danger g-btn' 
            onClick={()=>this.authenticate('google')}>
            <i className='fab fa-google'></i></button>
            <button 
            className='btn fb-btn' 
            onClick={()=>this.authenticate('facebook')}>
            <i className='fab fa-facebook-f'></i></button>
            <button 
            className='btn btn-outline-primary t-btn' 
            onClick={()=>this.authenticate('twitter')}>
            <i className='fab fa-twitter'></i></button>
            <button 
            className='btn btn-outline-dark gh-btn' 
            onClick={()=>this.authenticate('github')}>
            <i className='fab fa-github'></i></button>
            </div>
        )
    }

    changeToShow(elem){
        //console.log('elem',elem);
        this.setState({toShow:elem});
    }

    check(){
        let user = firebase.auth().currentUser;
        let pic = null;
        if(user){
           user = user.providerData["0"];
           pic = (user.providerId==='facebook.com') ? user.photoURL+'?type=large' : user.photoURL;
        }
        
        return(this.state.isSignedIn ? (
            
            <div>
             <Profile 
             name={user.displayName} 
             email={user.email} 
             pic={pic}/> 
             <div className='container' style={{paddingBottom: '35px'}}>
             <h3 className='App' style={{textAlign:"left"}}>Hi, {user.displayName.split(" ")[0]} you've successfully logged in..!</h3>
             <p>I haven't got any ideas for this page. <i className='far fa-sad-tear'></i> But you can help me by submitting an idea. <i className='far fa-lightbulb' ></i>  I'll save it in my MongoDB. <i className='far fa-smile-beam'></i></p>
             <p>You can also come back later and update your submitted idea <i className='far fa-surprise'></i> or delete it if you want. <i className='far fa-meh'></i></p>
             <p 
             style={{display:'inline-block'}}>So 
             <span onClick={()=>this.changeToShow('IdeaForm')} 
             className="div-link">submit a new idea</span> or 
             <span onClick={()=>this.changeToShow('GetIdea')} className="div-link">view/update your submitted idea(s)</span> ? 
             </p>
        
            {this.state.toShow==='IdeaForm'?<IdeaFrom user={user} changeToShow={this.changeToShow}/>:null}
            {this.state.toShow==='GetIdea'?<GetIdea user={user} />:null}
            </div>
            </div>
          ) : this.button()
       
        )
                  
    }

    render(){
        return(
            <div className="container-fluid">
                
               
                
                {this.state.isLoading ? <Loading /> : this.check()}
                
            </div>
        )
    }
}
function mapStateToProps(state){
    //console.log(state);
    return {user:state.user};
}

export default connect(mapStateToProps,{logUser,logoutUser,getIdea})(Goal);


// WEBPACK FOOTER //
// ./src/components/goals/index.jsx